import React,{Component} from 'react';
import { connect } from 'react-redux';
import {mediaPath } from "../../config";

class emailSent extends Component {
	componentDidMount() {}
	render(){
		return (
            <div className="login-block">
                <div className="login-inner-wrapper">
					<div className="logo"><a onClick={()=>{
										this.props.history.push('/login');
									}}><img src={mediaPath+"osah-logo.png"} alt="OSAH Logo" /></a></div>
					<div className="email-sent-section">
						<h2 className="title">Email Sent!</h2>
						<p className="subtitle">We sent an email to <a>{this.props.emailId}</a> <br/>Please check your email and follow the instructions to reset your password.</p>
						<p className="try-again">Didn't get the email? <a onClick={()=>{
										this.props.history.push('/forgotPassword');
									}}>Try Again</a></p>
					</div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state) {
  return {
	  emailId : state.userData.emailId,
  };
}

export default connect(mapStateToProps)(emailSent);